import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';

import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';
import FormAutoComplete from './../inputs/autocomplete'
import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { countries } from './../../countries'
import { getCurrencies } from './../../utils'
import { prepareForm, getLocalizedCountryFromCurrency } from './../../utils';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const ClientssEdit = () => {

    let navigate = useNavigate();
    const { usersAdminStore, clientsStore, companiesStore,utilsStore } = useStores();
    const { searchCompany } = companiesStore;
    const { searchConsultant } = usersAdminStore;
    const { getCurrencies,currencies } = utilsStore;
    const { getById, client, reset, save }  = clientsStore;
    //const { get, activity, reset } = activitiesStore;
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    const isNew = () => id && id == "new";

    useEffect(() => {        
        async function fetchMyAPI() {
            setIsLoading(true);            
            Promise.all([getById(id), getCurrencies()]).then(() => { setIsLoading(false);})
            
        }
        
        if (id == "new") {handleReset();} else {fetchMyAPI();}

    }, [getById,reset]);

    const handleReset = () => {
        reset();        
        setValidated(false);
    };
     
    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id","companyId","currency"]);
            //console.log(formData)
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const goToList = () => {
        navigate("/administration/clients")
    };
    
    return (       
        <Form noValidate validated={validated} onSubmit={handleSubmit} ref={formRef}>
            <Card>                
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            <Row>
                                <Col style={{ alignSelf: "center" }}  >
                                    <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../clients")} size="small" />
                                    <b>{t(isNew() ? 'newClient' : 'client')} {!isNew() && `(Id: ${id})`}</b>
                                    </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />
                            
                            <Row className="my-2">
                                <Col xs={3}>
                                    <FormText hidden isNumber id="id" type="number" object={client} />
                                    <FormText required label={t("clientName")} id="name" isLoading={isLoading} object={client} />
                                </Col>

                                <Col xs={2}>

                                    <FormText required label={t("winbizCode")} id="code" isLoading={isLoading} object={client} />
                                </Col>

                                <Col xs={3}>
                                    <FormAutoComplete onCreateClick={() => window.open('/administration/companies/new', '_blank')} itemFn={(option) => `${option.name} - (ID: ${option.id})`} service={searchCompany} validated={validated} required label={t("company")} id="company" formId="companyId" isLoading={isLoading} object={client} />                                    
                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormSelect onCreateClick={() => window.open('/administration/currencies/new', '_blank')} required label={t("currency")} id="currencyId" isLoading={isLoading} object={client} items={currencies?.map((x) => ({
                                        id: x.id, name: `${x.shortName} - ${getLocalizedCountryFromCurrency(x)}` }))} itemId="id" itemLabel="name"/>                                    
                                </Col>
                                <Col xs={4}>
                                    <FormText required label={t("paymentCondition")} id="paymentCondition" isLoading={isLoading} object={client} />  
                                </Col>
                            </Row>

                         
                            <hr />
                            <Col xs={8}>{isLoading ? <Skeleton /> : <b>{t("billingAddress")}</b>}</Col>


                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("corporateName")} id="corporateName" isLoading={isLoading} object={client} />
                                </Col>
                                <Col xs={4}>
                                    <FormText required lines={3} label={t("addressNo")} id="addressNo" isLoading={isLoading} object={client} />                                    
                                </Col>
                            </Row>


                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("postalCode")} id="postalCode" isLoading={isLoading} object={client} />
                                </Col>
                                <Col xs={4}>
                                    <FormText required label={t("city")} id="city" isLoading={isLoading} object={client} />                                    
                                </Col>
                            </Row>
                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(ClientssEdit);
